import React from 'react';
import AppLayout from '@/components/AppLayout';

const Index: React.FC = () => <AppLayout />;

export default Index;
